export default __webpack_public_path__ + "static/media/logo_website.7b51a9e1.png";